import { render, staticRenderFns } from "./button-dropdown-menu.vue?vue&type=template&id=678f144a&"
import script from "./button-dropdown-menu.vue?vue&type=script&lang=ts&"
export * from "./button-dropdown-menu.vue?vue&type=script&lang=ts&"
import style0 from "./button-dropdown-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports